module.exports = __webpack_public_path__ + "img/logo.0c7278b4.png";